export default "__VITE_ASSET__bdc8ade5__"